<template>
  <div id="app">

    <!--拷贝-->
    <div style="left: -100; top: -100; position: absolute; z-index: -1; color: rgba(0,0,0,0);  background-color: rgba(0,0,0,0);">
      <textarea id="copyObj" style="width: 1px; height: 1px;" readonly="true"></textarea>
      <canvas ref="canvas" style="display: none;"></canvas>
    </div>

    <!-- 提示信息 -->
    <div v-if="showPanel==1" style="text-align: center">
      <h1>{{showMsg}}</h1>
    </div>

    <!-- 等待拉单 -->
    <div v-if="showPanel==2">
      <!-- 旗舰  -->
      <basic-view v-if="orderInfo.productType=='phone_bill' ">
        <ProductPhoneBill :order-info="orderInfo" :pay-time-info="payTimeInfo" />
      </basic-view>
      <!-- 旗舰地址  -->
      <basic-view v-else-if="orderInfo.productType=='phone_bill_url' ">
        <ProductPhoneBillUrl :order-info="orderInfo" :pay-time-info="payTimeInfo" ref="aaaaaa" />
      </basic-view>
      <!-- 旗舰新  -->
      <ProductPhoneBalanceZfb :order-info="orderInfo" :pay-time-info="payTimeInfo" v-else-if="orderInfo.productType=='phone_balance'&&orderInfo.payType=='alipay' " />
      <ProductPhoneBalanceWx :order-info="orderInfo" :pay-time-info="payTimeInfo" v-else-if="orderInfo.productType=='phone_balance'&&orderInfo.payType=='weixin' " />
      <ProductPhoneBalanceDy :order-info="orderInfo" :pay-time-info="payTimeInfo" v-else-if="orderInfo.productType=='phone_balance'&&orderInfo.payType=='douyin' " />
      <basic-view v-else-if="orderInfo.productType=='phone_balance' ">
        <ProductPhoneBill :order-info="orderInfo" :pay-time-info="payTimeInfo" />
      </basic-view>
      <!-- 生活电费  -->
      <basic-view v-else-if="orderInfo.productType == 'life_electric'">
        <ProductLifeElectric :order-info="orderInfo" :pay-time-info="payTimeInfo" :alip-info="alipInfo" />
      </basic-view>
      <!-- 支付链接  -->
      <basic-view v-else-if="orderInfo.productType=='youka'||orderInfo.productType=='jd_dianfei'||orderInfo.productType=='yjf_dianfei'||orderInfo.productType=='electric_yd' ">
        <BasePan1 :order-info="orderInfo">
          <PayUrlComp :order-info="orderInfo" :pay-time-info="payTimeInfo" />
        </BasePan1>
      </basic-view>
      <!-- 微信链接内付  -->
      <basic-view v-else-if="orderInfo.productType=='phone_order'&&orderInfo.payType=='weixin_url_in' ">
        <ProductWeixUrlInner :order-info="orderInfo" :pay-time-info="payTimeInfo" />
      </basic-view>
      <!-- 支付链接  -->
      <basic-view v-else-if="orderInfo.productType=='phone_wangt'||orderInfo.productType=='phone_order'||orderInfo.productType=='phone_ydwt'||orderInfo.productType=='phone_tbalip' ">
        <ProductPayUrl :order-info="orderInfo" :pay-time-info="payTimeInfo" />
      </basic-view>
      <!-- 代付  -->
      <basic-view v-else-if="orderInfo.productType=='pdd_daifu'">
        <BasePan1 :order-info="orderInfo">
          <DaifuComp :order-info="orderInfo" :pay-time-info="payTimeInfo" />
        </BasePan1>
      </basic-view>
      <!-- Changelly  -->
      <basic-view v-else-if="orderInfo.productType=='changelly' ">
        <BasePan1 :order-info="orderInfo">
          <ProductChangelly :order-info="orderInfo" :pay-time-info="payTimeInfo" />
        </BasePan1>
      </basic-view>
      <!-- BankCard  -->
      <basic-view v-else-if="orderInfo.productType=='bankcard' ">
        <ProductBankcard :order-info="orderInfo" :pay-time-info="payTimeInfo" :qcode="bkQr" />
      </basic-view>
      <!-- vodafone  -->
      <basic-view v-else-if="orderInfo.productType=='vodafone' ">
        <ProductVodafone :order-info="orderInfo" :pay-time-info="payTimeInfo" ref="vodafone" />
      </basic-view>
      <!-- ProductBee  -->
      <basic-view v-else-if="orderInfo.productType=='IN_bee_ds'||orderInfo.productType=='IN_UPI_ds'||orderInfo.productType=='IN_bkcd_ds' ">
        <ProductBee :order-info="orderInfo" :pay-time-info="payTimeInfo" ref="in_bee" />
      </basic-view>
      <!-- ProductInOrig  -->
      <basic-view v-else-if="orderInfo.productType=='IN_Orig_ds' ">
        <ProductInOrig :order-info="orderInfo" :pay-time-info="payTimeInfo" ref="in_orig" />
      </basic-view>
      <!-- ProductVnbkcd  -->
      <basic-view v-else-if="orderInfo.productType=='vn_bkcd_ds' ">
        <ProductVnbkcd :order-info="orderInfo" :pay-time-info="payTimeInfo" ref="vn_bkcd_ds" />
      </basic-view>
      <!-- ProductNpbkcd  -->
      <basic-view v-else-if="orderInfo.productType=='np_bkcd_ds' ">
        <ProductNpbkcd :order-info="orderInfo" :pay-time-info="payTimeInfo" ref="npBkcdDs" />
      </basic-view>
      <basic-view v-else-if="orderInfo.productType=='np_bkcd2_ds' ">
        <ProductNpbkcd2 :order-info="orderInfo" :pay-time-info="payTimeInfo" ref="npBkcdDs" />
      </basic-view>
      <basic-view v-else-if="orderInfo.productType=='np_bkcd3_ds' ">
        <ProductNpbkcd3 :order-info="orderInfo" :pay-time-info="payTimeInfo" ref="npBkcdDs" />
      </basic-view>
      <basic-view v-else-if="orderInfo.productType=='np_bkcd4_ds' ">
        <ProductNpbkcd4 :order-info="orderInfo" :pay-time-info="payTimeInfo" ref="npBkcdDs" />
      </basic-view>
      <basic-view v-else-if="orderInfo.productType=='np_bkcd5_ds' ">
        <ProductNpbkcd5 :order-info="orderInfo" :pay-time-info="payTimeInfo" ref="npBkcdDs" />
      </basic-view>
      <basic-view v-else-if="orderInfo.productType=='np_bkcd6_ds' ">
        <ProductNpbkcd6 :order-info="orderInfo" :pay-time-info="payTimeInfo" ref="npBkcdDs" />
      </basic-view>
      <!-- ProductNpbkcd  -->
      <basic-view v-else-if="orderInfo.productType=='cr_bkcd_ds' ">
        <ProductCrbkcd :order-info="orderInfo" :pay-time-info="payTimeInfo" ref="crBkcdDs" />
      </basic-view>
      <!-- ProductDev  -->
      <basic-view v-else-if="orderInfo.productType=='prod_debug' ">
        <ProductDev :order-info="orderInfo" :pay-time-info="payTimeInfo" />
      </basic-view>
      <!-- 其他的  -->
      <basic-view v-else>
        <ProductNone :order-info=" orderInfo" :pay-time-info="payTimeInfo" />
      </basic-view>
    </div>

  </div>
</template>

<script>
// import FingerprintJS from "@/utils/fingerprintjs.v4.js"; //暂时去掉
import * as apis from "@/apis/apis";
import QRCode from "qrcode";
//
import BasicView from "@/views/basic";
import BasePan1 from "@/views/comp/sub/base_pan1";
//
import ProductPhoneBill from "@/views/comp/product_phone_bill";
import ProductPhoneBillUrl from "@/views/comp/product_phone_bill_url";
import ProductPhoneBalanceZfb from "@/views/comp/product_phone_balance_zfb";
import ProductPhoneBalanceWx from "@/views/comp/product_phone_balance_wx";
import ProductPhoneBalanceDy from "@/views/comp/product_phone_balance_dy";
import ProductLifeElectric from "@/views/comp/product_life_electric";
import ProductPayUrl from "@/views/comp/product_pay_url";
import ProductWeixUrlInner from "@/views/comp/product_weix_url_inner";
import PayUrlComp from "@/views/comp/pay_url_comp";
import DaifuComp from "@/views/comp/daifu_comp";
import ProductChangelly from "@/views/comp/product_changelly";
import ProductBankcard from "@/views/comp/product_bankcard";
import ProductVodafone from "@/views/comp/product_vodafone";
import ProductBee from "@/views/comp/product_bee";
import ProductInOrig from "@/views/comp/product_in_orig";
import ProductVnbkcd from "@/views/comp/product_vnbkcd";
import ProductNpbkcd from "@/views/comp/product_npbkcd";
import ProductNpbkcd2 from "@/views/comp/product_npbkcd2";
import ProductNpbkcd3 from "@/views/comp/product_npbkcd3";
import ProductNpbkcd4 from "@/views/comp/product_npbkcd4";
import ProductNpbkcd5 from "@/views/comp/product_npbkcd5";
import ProductNpbkcd6 from "@/views/comp/product_npbkcd6";
import ProductCrbkcd from "@/views/comp/product_crbkcd";
import ProductDev from "@/views/comp/product_dev";
import ProductNone from "@/views/comp/product_none";
export default {
  name: "App",
  components: {
    BasicView,
    BasePan1,
    ProductPhoneBill,
    ProductPhoneBillUrl,
    ProductPhoneBalanceZfb,
    ProductPhoneBalanceWx,
    ProductPhoneBalanceDy,
    ProductLifeElectric,
    ProductPayUrl,
    ProductWeixUrlInner,
    PayUrlComp,
    DaifuComp,
    ProductChangelly,
    ProductBankcard,
    ProductVodafone,
    ProductBee,
    ProductInOrig,
    ProductVnbkcd,
    ProductNpbkcd,
    ProductNpbkcd2,
    ProductNpbkcd3,
    ProductNpbkcd4,
    ProductNpbkcd5,
    ProductNpbkcd6,
    ProductCrbkcd,
    ProductDev,
    ProductNone,
  },
  data() {
    return {
      // URL参数
      id: null,
      uuid: null,
      debug: false,
      // 指纹
      visitorId: "",
      // 显示的面板
      showPanel: 1,
      showMsg: "Loading...",
      // 支付时间倒计时
      payTimeInfo: {
        timeDownOver: false, // 拉单结束
        timeDownNo: 60, // 拉单倒计时
        timePayoutMin: "--", //支付时间提示
        timePayoutSec: "--", //支付时间提示
        timeLastSss: 120000, // 支付倒计时毫秒数
        timeWebPayOver: 0, // web端支付结束时间
      },
      // 订单信息
      orderInfo: {
        orderId: "", //订单号
        productType: "", // 产品类型
        payType: "", // 支付类型
        amount: "", // 金额
        statePayd: "", //支付状态
        timePayLenSc: "", // 支付时间长度秒数
        // 设置-通道
        csTimeoutClose: false, //收银台超时是否关闭
        // 设置-客户配置
        csSetup1: false,
      },
      //支付宝信息
      alipInfo: {
        alipAuto: false, // 是否唤醒方式
        alipUrl: "", //  唤醒地址
        alipQr: false, //是否使用二维码
        alipQrURL: "", // 二维码图片地址
      },
      //
      bkQr: "",
      // 其他
      version: "v0.1",
      showLoad: 0,
      msgtxt: "",
    };
  },
  created() {
    this.$i18n.locale = "en";
    // 获取订单号
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    const uuid = params.get("uuid");
    if (id != null && id != "") {
      this.id = id;
    }
    if (uuid != null && uuid != "") {
      this.uuid = uuid;
    }
    if (this.id == null && this.uuid == null) {
      this.showPanel = 1;
      this.showMsg = this.$t("main['首页']");
      return;
    }
    // 获取debug
    let debug = params.get("debug");
    if (debug != null && debug == "true") {
      this.debug = true;
    }
    // 加载指纹
    // const fpPromise = FingerprintJS.load();
    // fpPromise
    //   .then((fp) => fp.get())
    //   .then((result) => {
    //     this.visitorId = result.visitorId;
    //     this.createPayInfo();
    //   })
    //   // eslint-disable-next-line
    //   .catch((error) => {
    //     this.createPayInfo();
    //   });
    //
    // 请求订单
    this.createPayInfo();
  },
  methods: {
    // 开始拉单
    createPayInfo() {
      // 提交已访问
      apis
        .createPayInfo({
          id: this.id,
          uuid: this.uuid,
          visitorId: this.visitorId,
          debug: this.debug,
        })
        .then((res) => {
          this.id = res.datas.id;
          // 强制设置语言
          if (res.datas.language) {
            this.$i18n.locale = res.datas.language;
          }
          // 设置基本信息
          this.orderInfo = Object.assign(this.orderInfo, res.datas);
          // 显示面板
          this.showPanel = 2;
          //拉单倒计时
          this.getPayTimedown();
          // 定时获取拉单信息
          this.getPayInfo();
        })
        .catch((err) => {
          this.showPanel = 1;
          this.showMsg = this.$t(`main['${err.errmsg}']`);
        });
    },
    // 拉单倒计时
    getPayTimedown() {
      let $that = this;
      //开始循环查询
      let timer = setInterval(function () {
        // 超过时间
        $that.payTimeInfo.timeDownNo--;
        if ($that.payTimeInfo.timeDownNo <= 0) {
          $that.payTimeInfo.timeDownNo = 0;
          clearInterval(timer);
          //标记失败
          $that.showMsg = $that.$t(`main['订单生成失败']`);
          return;
        }
        // 强制停止
        if ($that.payTimeInfo.timeDownOver) {
          clearInterval(timer);
          return;
        }
      }, 1000);
    },
    //获取支付信息
    getPayInfo() {
      apis
        .getPayInfo({
          id: this.id,
          debug: this.debug,
        })
        .then((res) => {
          if (res.datas == null) {
            //是否继续
            if (this.payTimeInfo.timeDownNo <= 0) {
              return;
            }
            // 继续下一次
            setTimeout(() => {
              this.getPayInfo();
            }, 1000);
          } else {
            this.payTimeInfo.timeDownOver = true; //标记结束
            // 设置主信息
            this.orderInfo = Object.assign(this.orderInfo, res.datas);
            // 不同产品类型的处理
            if (this.orderInfo.productType == "phone_bill") {
              // 暂无设置
            } else if (this.orderInfo.productType == "phone_balance") {
              //名字换成数组
              this.orderInfo.phoneOwners = [...this.orderInfo.phoneOwner];
              // 生成二维码;
              if (this.orderInfo.alipUrl) {
                QRCode.toDataURL(
                  this.orderInfo.alipUrl,
                  { errorCorrectionLevel: "L", margin: 2, width: 500 },
                  (err, url) => {
                    if (err) {
                      return;
                    }
                    this.orderInfo.alipQrURL = url;
                  }
                );
              }
            } else if (this.orderInfo.productType == "phone_bill_url") {
              // 暂无设置
            } else if (this.orderInfo.productType == "life_electric") {
              // 生成二维码;
              if (this.orderInfo.alipUrl) {
                QRCode.toDataURL(
                  this.orderInfo.alipUrl,
                  { errorCorrectionLevel: "L", margin: 2, width: 500 },
                  (err, url) => {
                    if (err) {
                      return;
                    }
                    this.orderInfo.alipQrURL = url;
                  }
                );
              }
            } else if (
              this.orderInfo.productType == "youka" ||
              this.orderInfo.productType == "jd_dianfei"
            ) {
              //window.location.href = payURL;
              // 暂无设置
            } else if (this.orderInfo.productType == "pdd_daifu") {
              // 暂无设置
            } else if (this.orderInfo.productType == "bankcard") {
              // 创建二维码图片
              if (this.orderInfo.qrcode) {
                // QRCode.toDataURL(
                //   this.orderInfo.qrcode,
                //   { errorCorrectionLevel: "L", margin: 2, width: 500 },
                //   (err, url) => {
                //     if (err) {
                //       console.log(err);
                //       return;
                //     }
                //     this.orderInfo.bcQr = url;
                //   }
                // );
                const size = 500;
                const canvas = this.$refs.canvas;
                const ctx = canvas.getContext("2d");
                const logoImage = new Image();
                // 生成二维码
                let $that = this;
                QRCode.toCanvas(canvas, this.orderInfo.qrcode, { width: size })
                  .then(() => {
                    logoImage.src = "/imgs/bc/ACB.png"; // 替换为你的logo图片地址
                    logoImage.onload = () => {
                      // 绘制logo
                      ctx.drawImage(
                        logoImage,
                        size * 0.4,
                        size * 0.4,
                        size * 0.2,
                        size * 0.2
                      );
                      // 导出合并后的图片
                      $that.bkQr = canvas.toDataURL("image/png");
                    };
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              }
            } else if (this.orderInfo.productType == "vodafone") {
              this.$refs.vodafone.initshowNums(); //初始化弹框号码
            } else if (
              this.orderInfo.productType == "IN_bee_ds" ||
              this.orderInfo.productType == "IN_UPI_ds" ||
              this.orderInfo.productType == "IN_bkcd_ds"
            ) {
              this.$refs.in_bee.init(); //初始化
            } else if (this.orderInfo.productType == "IN_Orig_ds") {
              this.$refs.in_orig.init(); //初始化
            } else if (this.orderInfo.productType == "vn_bkcd_ds") {
              this.$refs.vn_bkcd_ds.init(); //初始化
            } else if (
              this.orderInfo.productType == "np_bkcd_ds" ||
              this.orderInfo.productType == "np_bkcd2_ds" ||
              this.orderInfo.productType == "np_bkcd3_ds"
            ) {
              this.$refs.npBkcdDs.init(); //初始化
            }
            // //不同面板的处理
            // if (this.payPanel == "redirect") {
            //   //重定向的
            //   let payUrl = res.datas.payUrl;
            //   if (payUrl == null) {
            //     this.showPanel = 1;
            //     this.showMsg = this.$t(`main['发生错误']`);
            //     return;
            //   }
            //   window.location.href = payUrl;
            //   return;
            // } else {
            //   // 暂无设置
            // }
            //切换面板
            this.waitPayTimedown();
          }
        })
        // eslint-disable-next-line
        .catch((err) => {
          this.payTimeInfo.timeDownOver = true; //标记结束
          this.payTimeInfo.timeDownNo = 0; //标记结束
        });
    },
    // 待支付倒计时
    waitPayTimedown() {
      this.payTimeInfo.timeLastSss = this.orderInfo.timeLast; //设置服务端剩余的毫秒数
      this.payTimeInfo.timeWebPayOver = Date.now() + this.orderInfo.timeLast;
      // 计算剩余的分秒
      let $that = this;
      // eslint-disable-next-line
      let aaa = function (timer) {
        // 计算倒计时的时分秒
        // 方式1：使用服务器的时间戳开始递减
        // // 如果小于零则归零
        // if ($that.payTimeInfo.timeLastSss < 0) {
        //   $that.payTimeInfo.timeLastSss = 0; //归零
        // }
        // //如果已支付则归零
        // if ($that.orderInfo.statePayd == true) {
        //   $that.payTimeInfo.timeLastSss = 0; //归零
        // }
        // // 计算
        // var leftm = Math.floor($that.payTimeInfo.timeLastSss / (1000 * 60)); //计算分钟数
        // var lefts = Math.floor(($that.payTimeInfo.timeLastSss / 1000) % 60); //计算秒数
        // 方式2：使用web端的结束时间实时计算
        let timeShengyu = $that.payTimeInfo.timeWebPayOver - Date.now(); //剩余时间
        // 方式2.1 如果小于零则归零
        if (timeShengyu <= 0) {
          timeShengyu = 0; //归零
        }
        // 方式2.2 如果已支付则归零
        if ($that.orderInfo.statePayd == true) {
          timeShengyu = 0; //归零
        }
        // 方式2.3 计算
        var leftm = Math.floor(timeShengyu / (1000 * 60)); //计算分钟数
        var lefts = Math.floor((timeShengyu / 1000) % 60); //计算秒数
        // 最终
        $that.payTimeInfo.timePayoutMin = leftm.toString().padStart(2, 0); //前面补0
        $that.payTimeInfo.timePayoutSec = lefts.toString().padStart(2, 0); //前面补0
        //倒计时结束
        if ($that.payTimeInfo.timeLastSss <= 0) {
          return false; //停止执行
        } else {
          // 递减
          $that.payTimeInfo.timeLastSss -= 1000;
          //继续执行
          return true;
        }
      };
      // 先计算一次
      aaa();
      // 计时
      let num = 0; // 倒计时秒数
      let timer = setInterval(function () {
        num++;
        var subTime = false; //是否提交停留时间
        // 是否继续执行
        var continueFn = aaa();
        if (!continueFn) {
          subTime = true; //如果结束了也提交停留时间
          clearInterval(timer); //结束
        }
        // 5秒一次提交一次停留时间
        var nMo = num % 5;
        if (nMo == 0) {
          subTime = true;
        }
        //提交停留时间
        if (subTime) {
          apis
            .subTimes({
              id: $that.id,
            })
            // eslint-disable-next-line
            .then((res) => {
              // 是否支付
              $that.orderInfo.statePayd = res.datas.statePayd;
              //是否结束
              if (res.datas.stateFinish == true) {
                $that.payTimeInfo.timeLastSss = 0; // 时间清零
              }
            })
            // eslint-disable-next-line
            .catch((err) => {});
        }
      }, 1000);
    },
    // 复制
    copySome: function (text, type, cb, er) {
      if (navigator.clipboard && window.isSecureContext) {
        console.log("copy1");
        navigator.clipboard.writeText(text).then(cb).catch(er);
      } else {
        console.log("copy2");
        try {
          var textArea = document.getElementById("copyObj");
          textArea.value = text;
          //textArea.focus();
          textArea.select();
          textArea.setSelectionRange(0, 9999);
          document.execCommand("copy");
          textArea.setSelectionRange(0, 0);
          //成功
          cb();
        } catch (err) {
          er(err);
        }
      }
      this.copySub(type);
    },
    // 提交复制
    copySub: function (type) {
      apis
        .subCopy({
          id: this.id,
          type: type,
        })
        // eslint-disable-next-line
        .then((res) => {})
        // eslint-disable-next-line
        .catch((err) => {});
    },
    // 提交复制出错
    copyErr: function () {
      apis
        .subCopyErr({
          id: this.id,
        })
        // eslint-disable-next-line
        .then((res) => {})
        // eslint-disable-next-line
        .catch((err) => {});
    },
    // 同步跳转
    redirectUrl: function () {
      if (this.orderInfo.redirectUrl) {
        //postForm跳转
        if (this.orderInfo.redirectType == 1) {
          console.log("postForm");
        }
        //postJson跳转
        else if (this.orderInfo.redirectType == 2) {
          console.log("postJson");
        }
        //get
        else if (this.orderInfo.redirectType == 3) {
          window.location.href = this.orderInfo.redirectUrl;
        }
      }
    },
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
</style>
